module.exports = __webpack_public_path__ + "static/media/Collections-intimate-celebrations-Desktop.f6641375.jpg";